import React from 'react';
import PropTypes from 'prop-types';

import { useStaticQuery, graphql, Link } from 'gatsby'

import {format_team, format_subteam} from 'src/uglib_utils/teams.js';

function StaffList ({team, subteam}) {

    const data = useStaticQuery(graphql`
        query StaffListQuery {
            collections: allNodeStaffListEntry(sort: {field_staff_last_name: ASC}) {
            edges {
                node {
                field_domain_all_affiliates
                field_staff_campus
                field_staff_email_address
                field_staff_extension
                field_staff_first_name
                field_staff_last_name
                field_staff_title
                field_staff_picture {
                    alt
                    height
                    title
                    width
                }
                field_staff_subteam
                field_staff_team
                title
                id
                path {
                    alias
                }
                relationships {
                    field_staff_picture {
                    localFile {
                        childImageSharp {
                        gatsbyImageData
                        }
                    }
                    }
                }
                }
            }
            }
        }
    `);

    const collections = data.collections.edges;
    let filtered_collections = collections;

    // Filter to the team
    if(team !== null) {
        filtered_collections = filtered_collections.filter((element) => {
            return element.node.field_staff_team === team;
        })
    }

    // Filter to the subteam
    if(subteam !== null) {
        filtered_collections = filtered_collections.filter((element) => {
            return element.node.field_staff_subteam === subteam;
        })
    }

    // Format rows
    let collection_rows = filtered_collections.map((element) => {
        return (
            <tr className="table-row">
                <td><Link to={element.node.path.alias}>{element.node.field_staff_first_name}</Link></td>
                <td><Link to={element.node.path.alias}>{element.node.field_staff_last_name}</Link></td>
                <td className="team">{format_team(element.node.field_staff_team)}</td>
                <td className="subteam">{format_subteam(element.node.field_staff_subteam)}</td>
                <td>{element.node.field_staff_title}</td>
            </tr>
        )
    })

    let team_name = "Library";
    if (team !== null) {
        team_name = format_team(team);
    }

    if (subteam !== null) {
        team_name = format_subteam(subteam);
    }

    return (<>
        <h2>{team_name} Staff</h2>
        <table data-team={team} data-subteam={subteam} className="staff_list">
            <caption>A list of {team_name} staff</caption>
            <tr className="header">
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col" className="team">Team</th>
                <th scope="col" className="subteam">Subteam</th>
                <th scope="col">Title</th>
            </tr>
            {collection_rows}
        </table>
    </>);
       
}

StaffList.propTypes = {
	team: PropTypes.string,
    subteam: PropTypes.string
}

StaffList.defaultProps = {
    team: null,
    subteam: null
}

export default StaffList